import Block = App.Entities.Tasks.Ui.Block;
import {useBlockTypeLibrary} from './useBlockTypeLibrary';
import {useI18n} from 'vue-i18n';

export function getBlockName(block: Block): string {
  const {t} = useI18n();
  const library = useBlockTypeLibrary();
  const blockType = library.find(block.type);
  return blockType?.getName(block) || t('blockTypes.' + (blockType?.translationKey || 'unknown'));
}
